export class InputUtil {

  static maskPhoneNumberInput(value: string): string {
    if (value) {
      value = value.replace('+1', '');
      if (value.startsWith('1') && value.length > 10) {
        value = value.replace('1', '');
      }
      const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
    return value;
  }

  static formatTimeSpan(input: string) {
    return input ? ('00:' + ((input.length === 1 ? '0' : '') + InputUtil.replaceAll(input, ':', '') + '000').match(/.{1,2}/g).join(':')).slice(0, 8) : null;
  }

  static formatDistance(input: string) {
    return input ? ((InputUtil.replaceAll((input.length === 1 ? '0' : '') + input, '.', '') + '00').match(/.{1,2}/g).join('.')).slice(0, 5) : null;
  }

  static replaceAll(source: string, from: string, by: string) {
    return (source || '').split(from).join(by);
  }

  static parseBirthday(date: string) {
    return new Date(date).toUTCString().slice(0, 16);
  }

  static twoDigit(num) {
    num = '00' + num;
    return num.slice(num.length - 2, num.length);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/input.util.ts